import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';

export const AdminHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const navLinks = [
    { to: '/admin', label: 'Dashboard' },
    { to: '/admin/archive', label: 'Manage Posts' },
    { to: '/admin/blog', label: 'New Post' },
    { to: '/admin/meet-greet-grow', label: 'Event RSVPs' },
  ];

  const isActive = (path) =>
    path === '/admin' ? location.pathname === '/admin' : location.pathname.startsWith(path);

  return (
    <header className="bg-forest_deep border-b border-white/10 shadow-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo + nav */}
          <div className="flex items-center gap-8">
            <Link to="/admin" className="flex items-center gap-2.5 shrink-0">
              <span className="w-7 h-7 rounded-btn bg-gold/20 border border-gold/30 flex items-center justify-center">
                <svg className="w-4 h-4 text-gold_soft" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 3C8 3 4 7 4 12c0 3.5 2 6.5 5 8l3 1 3-1c3-1.5 5-4.5 5-8 0-5-4-9-8-9z" />
                </svg>
              </span>
              <span className="font-display font-bold text-cream text-sm tracking-wide hidden sm:block">OLI Admin</span>
            </Link>

            <nav className="hidden md:flex items-center gap-1" aria-label="Admin navigation">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 rounded-btn text-sm font-semibold transition-colors duration-200 ${
                    isActive(link.to)
                      ? 'bg-forest text-cream'
                      : 'text-cream/70 hover:text-cream hover:bg-white/5'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Right side: user + logout */}
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-gold/20 border border-gold/30 flex items-center justify-center">
                <span className="text-gold_soft font-bold font-display text-xs">
                  {adminUser?.username?.charAt(0).toUpperCase() || 'A'}
                </span>
              </div>
              <div className="leading-tight">
                <p className="text-cream text-xs font-semibold">{adminUser?.username || 'Admin'}</p>
                <p className="text-cream/50 text-[10px] capitalize">{adminUser?.role || 'admin'}</p>
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-btn border border-flag_red/40 text-flag_red hover:bg-flag_red hover:text-white text-xs font-bold uppercase tracking-label transition-colors duration-200"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span className="hidden sm:inline">Logout</span>
            </button>

            {/* Mobile menu toggle */}
            <button
              className="md:hidden p-2 rounded-btn text-cream/70 hover:text-cream hover:bg-white/5"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle mobile menu"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                {mobileOpen
                  ? <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  : <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile nav */}
        {mobileOpen && (
          <nav className="md:hidden border-t border-white/10 py-3 space-y-1" aria-label="Mobile admin navigation">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-2.5 rounded-btn text-sm font-semibold transition-colors duration-200 ${
                  isActive(link.to) ? 'bg-forest text-cream' : 'text-cream/70 hover:text-cream hover:bg-white/5'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
